import React, { lazy } from 'react';
import { AuthGuard } from '@nsd/fe';
import { Trello as ClaimsIcon, Search as SearchIcon } from 'react-feather';
import appIcon from './images/appIcon.png';
import TopBarAddOn from 'src/components/TopBarAddOn';
import DashboardLayout from 'src/layouts/DashboardLayout';
import i18next from 'i18next';

const MODULE = {
  CLAIMS: 'claims-22699c52-6508-4434-ad5a-27b6b8769152',
  FINANCE: 'finance-ab3da682-a735-4006-aeec-80ac2044f72b',
  MANAGEMENT: 'finance-ab3da682-a735-4006-aeec-80ac2044f72b'
};

const appConfig = {
  appId: 'claims-22699c52-6508-4434-ad5a-27b6b8769052',
  appName: 'Claims',
  titleKey: 'claims',
  priority: 2,
  path: 'claims',
  icon: appIcon,
  guard: AuthGuard,
  layout: DashboardLayout,
  routes: [
    {
      exact: true,
      path: 'browse-claim',
      view: lazy(() => import('src/views/claims/BrowseClaimView'))
    },
    {
      exact: true,
      path: 'file-claim',
      view: lazy(() => import('src/views/claims/create-claim'))
    },
    {
      exact: true,
      path: 'policy-search',
      view: lazy(() => import('src/views/claims/policy-search'))
    },
    {
      exact: true,
      path: 'policy-detail/:policyMasterId',
      view: lazy(() => import('src/views/claims/policy-detail'))
    },
    {
      exact: true,
      path: 'claims',
      redirect: 'browse-claim'
    },
  ],

  topBarConfig: {
    dataContextOptions: {
      enableDataContextOverride: true,
      customJSX: <TopBarAddOn />
    },
    contacts: false,
    search: false,
    notifications: true,
    settings: true,
    onDataContextChange: args => {
      console.log(args);
    }
  },
  navConfig: {
    navBarItems: [
      {
        subheader: "Claims",
        items: [
          {
            title: "Browse",
            href: 'browse-claim',
            icon: ClaimsIcon,
            module: MODULE.CLAIMS
          },
          {
            title: "Policy Search",
            href: 'policy-search',
            icon: SearchIcon,
            module: MODULE.CLAIMS
          }
        ]
      },
    ]
  }
};

export default appConfig;
